import { render, staticRenderFns } from "./BeautifulMenus.vue?vue&type=template&id=f48d7934&scoped=true&"
import script from "./BeautifulMenus.vue?vue&type=script&lang=js&"
export * from "./BeautifulMenus.vue?vue&type=script&lang=js&"
import style0 from "./BeautifulMenus.vue?vue&type=style&index=0&id=f48d7934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48d7934",
  null
  
)

export default component.exports